<div class="grid grid-cols-3 portrait:grid-cols-5 w-full">
  <span class="col-span-2 portrait:col-span-3 bg-lime-500 h-4"></span>
  <span class="col-span-1 portrait:col-span-2 bg-primary h-4"></span>
</div>
<div class="grid grid-cols-3 portrait:grid-cols-5 w-full">
  <span class="col-span-2 portrait:col-span-3 pl-12 pt-8">
    <img [src]="logoImage" class="w-44"/>
  </span>
  <span class="col-span-1 portrait:col-span-2 pt-8 grid grid-cols-2">
    <div>
      <p class="text-xs text-gray-800">Centro Terapéutico Cubic S.L.</p>
      <p class="text-xs text-gray-800">C/ Diego de Almagro 32, Local</p>
      <p class="text-xs text-gray-800">28342 Valdemoro, Madrid</p>
    </div>
    <div>
      <p class="text-xs text-gray-800">M: 605 13 00 39</p>
      <p class="text-xs text-gray-800">T : 910 34 00 39</p>
      <p class="text-xs text-gray-800">B-67688838</p>
    </div>
    <div>
      <p class="text-xs text-gray-800">centroterapeuticocubic.es</p>
      <p class="text-xs text-gray-800">info@centroterapeuticocubic.com</p>
    </div>
  </span>
</div>
